export default __webpack_public_path__ + "images/212492018208c70fcced8d6884c7d8a1.svg";